import { CallDto } from '@act/shared/data-transfer-objects';
import { createAction } from '@reduxjs/toolkit';
import { callsRequests } from '../requests/calls.request';
import { createApiThunk } from '../utils/apiThunk';

export const updateCallNoFollowUpNeeded = createApiThunk(
  callsRequests.updateCallNoFollowUpNeeded
);
export const getCallFilters = createApiThunk(callsRequests.getCallsFilters);
export const updateSubjectId = createApiThunk(callsRequests.updateSubjectId);
export const unassignCall = createApiThunk(callsRequests.unassignCall);
export const getCallReviewTasks = createApiThunk(
  callsRequests.getCallReviewTask
);
export const updateCallReview = createApiThunk(callsRequests.updateCallReview);
export const getActiveCalls = createApiThunk(callsRequests.getActiveCalls);
export const getSuggestions = createApiThunk(callsRequests.getSuggestions);
export const updateSubjectIdSuccess = createAction<CallDto>(
  'calls/updateSubjectIdSuccess'
);
export const unassignCallSuccess = createAction<CallDto>(
  'calls/unassignCallSuccess'
);
